import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from '../../core/services/http.service';
import { Params } from './pages/tabs/users/models/params.model';

@Injectable({ providedIn: 'root' })
export class SettingsService {

  private addUrl = 'partners/settings/add-user';
  private addUserMerchantUrl = 'partners/settings/add-user-merchant';

  private saveAccountUrl = 'partners/settings/save-account';
  private getAllUsersUrl = 'partners/settings/all-users';
  private getDeveloperUrl = 'partners/settings/developer';
  private saveEndpointUrl = 'partners/settings/save-endpoint';
  private reportsUrl = 'partners/settings/reports';
  private getUserUrl = 'partners/settings/get-user';

  private getAllUsersMerchantUrl = 'partners/merchants/settings/all-users-merchant';

  private getUrl = 'partners/settings/account';
  private profileUrl = 'partners/settings/user';
  private updatePasswordUrl = 'partners/settings/update-password';
  private confirmPasswordUrrl = 'partners/settings/confirm-password';
  private updateUrl = 'partners/settings/update-user';
  private updateUserMerchantUrl = 'partners/settings/update-user-merchant';

  private updateThemeUrl = 'partners/settings/update-theme';
  private enableUserUrl = 'partners/settings/enable-user';
  private resendEmailUserUrl = 'partners/settings/resend-email';
  private downloReportUrl = 'partners/settings/download-report';
  private getServicesUrl = 'partners/settings/movidesk-services';
  private getEndpointsUrl = 'partners/settings/endpoints';
  private cepUrl = 'partners/settings/cep';
  private createTicketUrl = 'partners/settings/create-ticket';
  private getAccountByKeyUrl = 'partners/settings/get-account-by-key';;

  private updateRoleUrl = 'partners/settings/update-role';
  private createUrl = 'partners/settings/create';

  private getConfigurationsUrl = 'partners/general/get-configurations';
  private updateConfigurationsUrl = 'partners/general/update-configurations';
  private removeConfigurationsPropertyUrl = 'partners/general/remove-configurations-property';

  private circularizationLetterUrl = 'partners/settings/circularization-letter';

  user: any;
  partner: any;
  merchant: any;

  private userSource = new BehaviorSubject<any>({});
  currentUser = this.userSource.asObservable();
  private partnerSource = new BehaviorSubject<any>({});
  currentParnter = this.partnerSource.asObservable();
  private merchantSource = new BehaviorSubject<any>({});
  currentMerchant = this.merchantSource.asObservable();

  constructor(private httpService: HttpService) {
  }

  get(partner: string, account: string) {
    return this.httpService.get(this.getUrl, partner, account, true);
  }

  getAccountByKey(partner: string, account: string, accountKey: string) {
    return this.httpService.post(this.getAccountByKeyUrl, { account: accountKey }, partner, account, true);
  }

  profile(partner: string, account: string) {
    return this.httpService.get(this.profileUrl, partner, account, true);
  }

  getAllUsers(partner: string, account: string, params: Params) {
    return this.httpService.post(this.getAllUsersUrl, params.createPost(), partner, account, true);
  }

  getAllUsers2(partner: string, account: string, params) {
    return this.httpService.post(this.getAllUsersUrl, params, partner, account, true);
  }

  updateUser(partner: string, account: string, params) {
    return this.httpService.post(this.updateUrl, params, partner, account);
  }

  updateUserMerchant(partner: string, account: string, params) {
    return this.httpService.post(this.updateUserMerchantUrl, params, partner, account);
  }

  updateTheme(partner: string, account: string, params) {
    return this.httpService.post(this.updateThemeUrl, params, partner, account);
  }

  enableUser(partner: string, account: string, params) {
    return this.httpService.post(this.enableUserUrl, params, partner, account);
  }

  resendEmail(partner: string, account: string, params) {
    return this.httpService.post(this.resendEmailUserUrl, params, partner, account);
  }

  addUser(partner: string, account: string, params) {
    return this.httpService.post(this.addUrl, params, partner, account);
  }

  addUserMerchant(partner: string, account: string, params) {
    return this.httpService.post(this.addUserMerchantUrl, params, partner, account);
  }

  updatePassword(partner: string, account: string, params) {
    return this.httpService.post(this.updatePasswordUrl, params, partner, account);
  }

  confirmPassword(partner: string, account: string, params) {
    return this.httpService.post(this.confirmPasswordUrrl, params, partner, account);
  }

  changeUser(user) {
    this.userSource.next(user)
  }

  changePartner(partner) {
    this.partnerSource.next(partner)
  }

  changeMerchant(merchant) {
    if (merchant.external_id !== this.merchantSource.value?.external_id) {
      this.merchantSource.next(merchant)
    }
  }

  updateRole(partner: string, account: string, params) {
    return this.httpService.post(this.updateRoleUrl, params, partner, account);
  }

  saveAccount(partner: string, account: string, params) {
    return this.httpService.post(this.saveAccountUrl, params, partner, account);
  }

  getCep(partner: string, account: string, cep) {
    return this.httpService.get(`${this.cepUrl}/${cep}`, partner, account, true);
  }

  getDeveloper(partner, account, params) {
    return this.httpService.post(`${this.getDeveloperUrl}`, params, partner, account);
  }

  getEndpoints(partner, account) {
    return this.httpService.get(`${this.getEndpointsUrl}`, partner, account, true);
  }

  saveEndpoint(partner, account, params) {
    return this.httpService.post(this.saveEndpointUrl, params, partner, account);
  }

  create(partner, account) {
    return this.httpService.get(this.createUrl, partner, account, true);
  }

  getReports(partner, account, params) {
    return this.httpService.post(this.reportsUrl, params, partner, account, true);
  }

  getReportsById(partner, account, id) {
    return this.httpService.get(`${this.reportsUrl}/${id}`, partner, account, false);
  }

  download(partner, account, params) {
    return this.httpService.postDown(this.downloReportUrl, params, partner, account, true, true);
  }

  getAllUsersMerchant(partner: string, account: string, params) {
    return this.httpService.post(this.getAllUsersMerchantUrl, params, partner, account, true);
  }

  getUser(partner: string, account: string, params) {
    return this.httpService.post(this.getUserUrl, params, partner, account, true);
  }


  getServices(partner: string, account: string) {
    return this.httpService.get(this.getServicesUrl, partner, account, true);
  }

  createTicket(partner: string, account: string, params) {
    return this.httpService.post(this.createTicketUrl, params, partner, account, true);
  }

  getConfigurations(partner: string, account: string) {
    return this.httpService.get(this.getConfigurationsUrl, partner, account, true);
  }

  updateConfigurations(partner: string, account: string, configurations: string) {
    const params = {
      configurations
    }

    return this.httpService.post(this.updateConfigurationsUrl, params, partner, account, true);
  }

  removeConfigurationsProperty(partner: string, account: string, property: string) {
    const params = {
      property
    }

    return this.httpService.post(this.removeConfigurationsPropertyUrl, params, partner, account, true);
  }

  downloadLetter(partner: string, account: string, date) {
    const params = {
      date
    }
    return this.httpService.post(this.circularizationLetterUrl, params, partner, account, true);
  }
}
